export function authHeader() {
    // return authorization header with jwt token
    let token = localStorage.getItem('access_token');

    if (token ) {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js